import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CheckoutHeader from './CheckoutHeader';
import OrderSummary from './OrderSummary';
import OrderDetails from './OrderDetails'

const theme = createTheme();

function Checkout({ 
    state,
    edit, 
    remove,     
}) {
	return (
    	<ThemeProvider theme={theme}>
  		<CssBaseline />
  		<Container maxWidth="md">                         
            <main>        
                <CheckoutHeader                 
                    edit={edit}
                />   
                <Grid container spacing={4}>    
                    <Grid item xs={12} md={8}>    
                        <OrderSummary 
                            state={state}
                            remove={remove}                        
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>    
                        <OrderDetails 
                            state={state}
                        />
                        <Box sx={{ mt: 2}}>
                            <Button 
                                sx={{ width: '100%'}} 
                                color="success" 
                                variant="contained" 
                                onClick={() => alert(`Your order is being processed`)}
                            >Order
                            </Button>
                        </Box>
                    </Grid>
                    
               </Grid>
            </main>       
  		</Container>      		
    </ThemeProvider>
  );
}

export default Checkout;